import React from "react";
import t from "../../../i18n";
import NavV2 from "@ui/NavV2";
import Tab from "@ui/NavV2/Tab";
import { useLocation } from "react-router";

export function ClassificationNavigation() {
  const location = useLocation();
  return (
    <NavV2>
      <Tab
        to="/administration/classification/quantities"
        active={location.pathname === "/administration/classification/quantities"}
      >
        {t("administration.classification.header.quantities")}
      </Tab>
      <Tab
        to="/administration/classification/failures"
        active={location.pathname === "/administration/classification/failures"}
      >
        {t("administration.classification.header.failures")}
      </Tab>
    </NavV2>
  );
}
